const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

const io = new IntersectionObserver((entries) => {
  for (const e of entries) {
    if (e.isIntersecting) {
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    }
  }
}, { rootMargin: '0px 0px -12% 0px' });

function scan(root = document) {
  root.querySelectorAll('[data-reveal]:not(.is-in)').forEach((el) => (reduced ? el.classList.add('is-in') : io.observe(el)));
}

const parallax = new Set();
const watch = new IntersectionObserver((entries) => {
  for (const e of entries) e.isIntersecting ? parallax.add(e.target) : parallax.delete(e.target);
  frame();
}, { rootMargin: '200px 0px' });
function track(root = document) {
  if (reduced) return;
  root.querySelectorAll('[data-parallax]').forEach((el) => watch.observe(el));
}

let ticking = false;
function frame() {
  ticking = false;
  const vh = innerHeight;
  for (const el of parallax) {
    const r = el.getBoundingClientRect();
    if (r.bottom < -200 || r.top > vh + 200) continue;
    const progress = (r.top + r.height / 2 - vh / 2) / vh;
    const speed = +(el.dataset.parallax || 0.15);
    el.style.setProperty('--py', `${(-progress * speed * 100).toFixed(2)}px`);
    el.style.setProperty('--pr', (progress).toFixed(3));
  }
}
addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });

function init(root) { scan(root); track(root); frame(); }
init();
document.addEventListener('shopify:section:load', (e) => init(e.target));
